import ProgrammeImage1 from "../../../../../assets/images/png/courses/international/programme1.webp";
import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const businessAnalysisSchoolDataEurope = {
  tag: "Business Analysis",
  id: "businessAnalysisSchool",
  url: "/business-analysis-school",
  image: SchoolImage,

  name: "Business Analysis School",
  description: `
  The Utiva Business Analysis Program is designed to help you learn more about the 
  lifecycle of business analysis, from assessing needs and working with stakeholders to
   developing requirements and coordinating with project managers. 
  `,
  keywords: `business, business analysis school, business analysis`,
  metatags: `Utiva is the best place to learn business analysis in Nigeria. We train you and help you become certified in business analysis.`,

  courses: [
    {
      id: 2,
      courseImage: ProgrammeImage1,
      courseName: "Business Analysis Bootcamp",
      courseDescription: `
      From concept to practice, explore the knowledge, tools, and techniques that make a great business analyst.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "2 Months",

      courseTags: ["For Early Professionals"],

      courseUrl: "/business-analysis-bootcamp",

      enrolUrl: "https://learn.utiva.io/enroll/2063596?price_id=2792250",

      bookCallUrl: "https://calendar.app.google/W9uJ5PxuwoottUjt6",
      chatWithUsUrl: "https://wa.me/447495380293",
    },
  ],
  testimony: {
    // testimonierImage: TestimonialImage,
    testimonierName: "Ope Oyenowo",
    testimonierTitle: "Business Anaylst",
    testimonyDescription: `I was not exactly sure what I will get at the 
    end of the day but I trusted this because Utiva had a very known name. 
    I enrolled in the 4 month learning program and I can tell you that it 
    was worth my time. I moved to Dublin before the training 
    was completed and got a new job in Dublin. Very exciting journey. `,
  },

  article: [],

  careerTitle: "Business Anaylst",

  careerPaths: ["Business Anaylst", "Business Manager"],

  quickFactSalary: "$120,000 ",

  quickFacts: [
    "Business Analysis has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum, citing it as the next wave of information technology for individuals, companies and governments.",
  ],
};
